import React, {Fragment} from 'react'
import {translate} from 'react-i18next'

import SeparatorLine from './SeparatorLine'
import SeparatorView from './SeparatorView'
import SeparatorLinkWord from './SeparatorLinkWord'

const Separator = ({t, className, withText}) => (
  <SeparatorView className={className}>
    <SeparatorLine />
    {withText && (
      <Fragment>
        <SeparatorLinkWord>{t('separator-or')}</SeparatorLinkWord>
        <SeparatorLine />
      </Fragment>
    )}
  </SeparatorView>
)

export default translate()(Separator)
